import React from 'react';
// import { Button } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';

import EditPassword from './edit-password';

const  editPasswordModal = (intl, user, dispatch, setShow) => {
  confirmAlert({
    closeOnClickOutside: false,
    customUI: ({ onClose }) => {
      return (
        <div className='edit-password-modal'>
          <EditPassword onClose={onClose} setShow={setShow} intl={intl} user={user} dispatch={dispatch} />
        </div>
      );
    }
  });
};

export default editPasswordModal;